const LOYALTY_PROGRAMS_FIELD = 'https://accounts.ikea.com/loyaltyPrograms';
const CUSTOMER_TYPE_FIELD = 'https://accounts.ikea.com/customerType';
const MEMBER_ID_FIELD = 'https://accounts.ikea.com/memberId';
const RETAIL_UNIT_FIELD = 'https://accounts.ikea.com/retailUnit';
const PARTY_UID_FIELD = 'https://accounts.ikea.com/partyUId';

interface IkeaJwtPayload {
  iss?: string;
  sub?: string;
  aud?: string[] | string;
  exp?: number;
  nbf?: number;
  iat?: number;
  jti?: string;
  [LOYALTY_PROGRAMS_FIELD]?: string[];
  [CUSTOMER_TYPE_FIELD]?: string;
  [MEMBER_ID_FIELD]?: string;
  [RETAIL_UNIT_FIELD]?: string;
  [PARTY_UID_FIELD]?: string;
}

function jwtDecode(token: string): IkeaJwtPayload {
  var base64Url = token.split('.')[1];
  var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  var jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split('')
      .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
      .join('')
  );
  return JSON.parse(jsonPayload) as IkeaJwtPayload;
}

export const getPartyUId = (token: string | undefined): string => {
  if (!token) {
    return '';
  }
  const payload: IkeaJwtPayload = jwtDecode(token);
  return payload[PARTY_UID_FIELD] ?? payload.sub ?? '';
};

export const getIkeaFamilyStatus = (token: string | undefined): boolean => {
  if (!token) {
    return false;
  }
  const payload: IkeaJwtPayload = jwtDecode(token);
  const loyaltyPrograms = payload[LOYALTY_PROGRAMS_FIELD] ?? [];
  return (
    Array.isArray(loyaltyPrograms) && loyaltyPrograms.includes('IKEA_FAMILY')
  );
};

export const getRetailUnit = (token: string | undefined): string => {
  if (!token) {
    return '';
  }
  const payload: IkeaJwtPayload = jwtDecode(token);
  return (payload[RETAIL_UNIT_FIELD] ?? '').toLowerCase();
};
